/**
 * RevenueMetrics - Revenue & Financial Metrics section
 */
import React from 'react';
import { DollarSign, Activity, Users, BarChart3 } from 'lucide-react';
import { MetricCard, MetricSection, MetricGrid } from '../MetricCard';
import { formatValue } from '../analyticsFormatters';

export function RevenueMetrics({ snapshotData }) {
  const summary = snapshotData?.summary || {};
  
  return (
    <MetricSection title="Revenue & Financial Metrics">
      <MetricGrid cols={4}>
        <MetricCard
          icon={DollarSign}
          iconColor="bg-green-100 dark:bg-green-900/20"
          title="Monthly Recurring Revenue"
          value={formatValue(summary.currentMRR || 0, 'currency')}
        />
        <MetricCard
          icon={Activity}
          iconColor="bg-yellow-100 dark:bg-yellow-900/20"
          title="ARR (Estimated)"
          value={formatValue((summary.currentMRR || 0) * 12, 'currency')}
          subtitle="Annual run rate"
          subtitleColor="text-yellow-600 dark:text-yellow-400"
        />
        <MetricCard
          icon={Users}
          iconColor="bg-blue-100 dark:bg-blue-900/20"
          title="Paying Customers"
          value={formatValue(summary.payingCustomers || 0, 'number')}
          subtitle={`of ${formatValue(summary.totalUsers || 0, 'number')} total users`}
        />
        <MetricCard
          icon={BarChart3}
          iconColor="bg-orange-100 dark:bg-orange-900/20"
          title="ARPU"
          value={formatValue(summary.averageRevenuePerUser || 0, 'currency')}
          subtitle="per paying customer"
        />
      </MetricGrid>
    </MetricSection>
  );
}

